<template>
    <div>
        <div>
            <RadioGroup v-model="goodsStatus">
                <Radio label="全部"></Radio>
                <Radio label="未使用"></Radio>
                <Radio label="已使用"></Radio>
                <Radio label="已过期"></Radio>
            </RadioGroup>
        </div>
        <Table style="margin-top: 16px;" ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <template v-slot:avatarUrl="{ row }">
                <base-img height="30" width="30" :src="row.avatarUrl"></base-img>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            placement="top"
            @change="fetch"
        ></table-pager>
    </div>
</template>
<script>
import { mapCell, pipeCell } from "_c/grid/renderCell";
import { cInfoDetailList } from "@/api/market";
import Dict from "_u/dict";
import BaseImg from "_c/base-img";

const PAGE_SIZE = 20;

export default {
    name: "c-info-detail-list",
    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
            },
            page: {
                total: 0,
                list: [],
            },
            dict: {
                taskType: Dict.NULL,
            },
            goodsStatus: "全部", // 优惠券状态
            useStatus: 0, // 优惠券状态码
        };
    },

    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "nickname",
                    title: "领取人",
                    align: "left",
                    minWidth: 160,
                },
                {
                    key: "avatarUrl",
                    title: "微信头像",
                    align: "center",
                    minWidth: 100,
                    slot: "avatarUrl",
                },
                {
                    key: "createTime",
                    title: "领取时间",
                    align: "center",
                    minWidth: 160,
                    render: pipeCell("ymdL"),
                },
                {
                    key: "usedText",
                    title: "状态",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "endDate",
                    title: "有效期",
                    align: "center",
                    minWidth: 160,
                    render: pipeCell("ymdL"),
                },
            ];
        },
    },

    watch: {
        goodsStatus: function (newVal, oldVal) {
            if (this.goodsStatus === "全部") {
                this.useStatus = 0;
            } else if (this.goodsStatus === "未使用") {
                this.useStatus = 1;
            } else if (this.goodsStatus === "已使用") {
                this.useStatus = 2;
            } else if (this.goodsStatus === "已过期") {
                this.useStatus = 3;
            }
            this.filter.pageNo = 1;
            this.fetch();
        },
    },

    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.loading = true;
            var viewData = Object.assign(this.filter, {
                couponId: this.id,
                useStatus: this.useStatus,
            });

            Promise.all([Dict.get(["task_type"]), cInfoDetailList(viewData)])
                .then((args) => {
                    var [dictGroup, page] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    const nowTime = new Date().getTime();
                    page.data.page.list.forEach((item) => {
                        if (item.used === 0) {
                            if (nowTime < item.endDate) {
                                item.usedText = "未使用";
                            } else {
                                item.usedText = "已过期";
                            }
                        } else if (item.used === 1) {
                            item.usedText = "已使用";
                        }
                    });
                    this.setPageData(page.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },

        setPageData(data) {
            this.page.list = data.page.list;
            this.page.total = parseInt(data.page.totalCount);
        },

        onClickGrade(e) {
            this.modal.showMGradeForm = true;
        },
    },
};
</script>
<style lang="less" scoped></style>
